var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-components"},[(_vm.messgeCount > 0)?_c('div',{staticClass:"notice-body"}):_vm._e(),_vm._v(" "),_c('messageNoticeAdmin',{ref:"messageNoticeAdmin",on:{"tableReload":_vm.getNoReadList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }